import React, { useEffect, useState } from "react";
import "./CarWashingFactor.scss";
import ServiceProduct from "./ServiceProduct/ServiceProduct";
import LeftSideCarwashFactor from "../CarWashFactor/LeftSideCarwashFactor";
import _axios from "../../../httpService";
import utilsFunction from "../../../utils/utilsFunction";
import Loader from "../../Loader";
import { useLocation } from "react-router-dom";


const CarWashingFactor = () => {
  const [factorData, setFactorData] = useState({
    isOpenModalSelectCarRLookUp: false,
    rLookUpData: {},
    isOpenSelectWorkerModal: false,
    lastServiceSelectedId: "",
    sum: 0,
  });
  const [factorDataNoTax, setFactorDataNoTax] = useState(0);
  const prefixUrl = localStorage.getItem("apiUrl");
  const [initialData, setInitialData] = useState({});
  const [sendData, setSendData] = useState({});
  const [loading, setLoading] = useState(true);
 
  const location = useLocation();
  let factor = "";
  if (location.state !== null) {
    factor = location.state.id;
  }

  useEffect(() => {
    let idForRequest = "";

    if (location.state !== null) {
      idForRequest = "&id=" + location.state.id;
    }

    _axios
      .get(prefixUrl + "/carwashFactor/?request=details" + idForRequest)
      .then((res) => {
        const backEndData = res.data;
        setInitialData(backEndData);
        let temp = {};
        if (idForRequest !== "") {
          temp = res.data?.factorSubmittedData;
          temp = {
            ...temp,
            factorId: location.state.id,
            mode: "edit",
          };
          setFactorData({
            ...factorData,
            rLookUpData: res.data.factorSubmittedData.IDKHOD,
          });
        } else {
          temp = {
            IDKHOD: "",
            status: "inQueue", // inProcess
            services: [],
            reward: "",
            products: [],
            discount: "",
            tax: backEndData.tax,
            mode: "add",
          };
        }

        setSendData(temp);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    const products = sendData.products;
    const services = sendData.services;
    const sumProducts = products?.reduce((a, b) => {
      let temp = b.price - +b.discount;
      if (b.number > 1) {
        temp = (+b.price - +b.discount) * +b.number;
      }
      return +a + +temp;
    }, 0);

    const sumServices = services?.reduce((a, b) => {
      let temp = b.price - +b.discount;
      if (b.number > 1) {
        temp = (+b.price - +b.discount) * +b.number;
      }
      return +a + +temp;
    }, 0);

    const rewardPrice =
      sendData.reward === ""
        ? 0
        : parseInt(utilsFunction.removeComma(sendData.reward));
    const discountPrice = sendData.discount !== 0 ? sendData.discount : 0;

    let sum =
      parseInt(sumProducts) +
      parseInt(sumServices) +
      rewardPrice -
      discountPrice;
    let sumNoTax =
      parseInt(sumProducts) +
      parseInt(sumServices) +
      rewardPrice -
      discountPrice;

    sum =
      sendData.tax !== 0 || sendData.tax !== ""
        ? sum + (sum * sendData.tax) / 100
        : sum;
    setFactorData({ ...factorData, sum });
    setFactorDataNoTax(sumNoTax);
  }, [sendData]);
  return (
    <div className="main-CarWashFactor">
      {loading ? (
        <Loader />
      ) : (
        <>
          <ServiceProduct
            initialData={initialData}
            setSendData={setSendData}
            sendData={sendData}
          />

          <LeftSideCarwashFactor
            initialData={initialData}
            setSendData={setSendData}
            sendData={sendData}
            factorData={factorData}
            setFactorData={setFactorData}
            factorDataNoTax={factorDataNoTax}
            customId={factor}
          />
        </>
      )}
     
    </div>
  );
};
export default CarWashingFactor;
